require('./_accordion.scss')

const Accordion = {

  init: function (element) {
    const _ = this
    const triggers = element.querySelectorAll('button[aria-expanded]')
    _.el = element
    for (const trigger of triggers) {
      trigger.addEventListener('click', (e) => {
        _.triggerClick(e.currentTarget, _)
      }, false)
    }
  },

  triggerClick: function (target, _) {
    const parent = target.parentNode
    if (!parent.classList.contains('active')) {
      Array.from(_.el.querySelectorAll('.accordion__item.active')).forEach(function (el) {
        _.toggleItem(el, false)
      })
      _.toggleItem(parent, true)
    } else {
      _.toggleItem(parent, false)
    }
  },

  toggleItem: function (item, open) {
    const itemTrigger = item.querySelector('.accordion__item-trigger')
    const itemContent = item.querySelector('.accordion__item-content')
    const itemContentHeight = itemContent.scrollHeight

    item.classList.add('animating')
    itemContent.style.height = itemContentHeight + 'px'

    if (open) {
      setTimeout(function () {
        item.classList.remove('animating')
        itemContent.style.height = null
      }, 350)
      item.classList.add('active')
    } else {
      setTimeout(() => { itemContent.style.height = null }, 0)
      setTimeout(() => {
        item.classList.remove('animating')
      }, 350)
      item.classList.remove('active')
    }

    itemTrigger.setAttribute('aria-expanded', `${open}`)
    itemContent.setAttribute('aria-hidden', `${!open}`)
  }
}

export default Accordion
